import { create } from 'zustand'
import { createJSONStorage, devtools, persist } from 'zustand/middleware'

interface HideCompletedStateValues {
  hideCompleted: boolean
}

interface HideCompletedState extends HideCompletedStateValues {
  toggleHideCompleted: () => void
}

const initialState: HideCompletedStateValues = {
  hideCompleted: true,
}

const useHideCompletedStore = create<HideCompletedState>()(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        toggleHideCompleted: () => {
          set(() => ({
            hideCompleted: !get().hideCompleted,
          }))
        },
      }),
      {
        name: 'moly-hide-completed',
        storage: createJSONStorage(() => localStorage),
      },
    ),
  ),
)

export default useHideCompletedStore
